import React, { useEffect } from 'react'
import { useDangerModel } from '../dangerModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import useGlobalModel from '@/model/globalModel'
import { assignStatusList } from '@/types/AppEnums'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData, companyData, fetchCompanyList, maintenanceTypeList } = useDangerModel()
    const {
        authData,
        user: { userType },
    } = useGlobalModel(({ user }) => [user])

    useEffect(() => {
        fetchCompanyList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchFields: any = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '司机/押运员/车牌号',
            fieldName: 'retrieveName',
            span: 6,
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '维修技师',
            fieldName: 'technicianName',
            span: 6,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '选择维修类型',
            fieldName: 'maintenanceType',
            options: maintenanceTypeList,
            span: 6,
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: '',
            rangePickerFieldName: ['startTime', 'endTime'],
            // placeholder: ["申请起始日期", "申请结束日期"],
            format: 'YYYY-MM-DD',
            alloc: true,
            span: 6,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '选择状态',
            fieldName: 'itemStatus',
            options: assignStatusList,
            span: 6,
        },
        ...((str) => {
            if (str) {
                return [
                    {
                        type: SearchTypeEnum.Select,
                        placeholder: '选择管理员',
                        fieldName: 'createUser',
                        mode: 'multiple',
                        options: authData.filter((item) => item.type === '管理员'),
                    },
                ]
            } else {
                return []
            }
        })(userType === '超级管理员'),
        {
            type: SearchTypeEnum.Select,
            placeholder: '产权公司',
            fieldName: 'company',
            options: companyData,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
            style={{ height: 'auto' }}
        />
    )
}
